import { styled } from '@abyss/web/tools/styled';
import { Modal } from '@abyss/web/ui/Modal';
import { IconBrand } from '@abyss/web/ui/IconBrand';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';

export const pageBodyMaxWidth = 463;

export const StyledIconSymbol = styled(IconSymbol, {
  marginTop: '91px',
  '@screen < $sm': {
    marginTop: '52px',
  },
});

export const StyledIconBrand = styled(IconBrand, {
  marginTop: '91px',
  '@screen < $sm': {
    marginTop: '52px',
  },
});

export const StyledErrorTitle = styled(Modal.Section, {
  fontWeight: '700',
  fontSize: '22.78px',
  lineHeight: '32px',
  padding: '0 0 0 0',
  '@screen < $sm': {
    fontSize: '18px',
    lineHeight: '24px',
  },
});

export const StyledErrorMessage = styled(Modal.Section, {
  fontWeight: '500',
  fontSize: '14px',
  lineHeight: '18px',
  textAlign: 'center',
  padding: '0 0 68px 0',
  '@screen < $sm': {
    padding: '0 0 84px 0',
  },
});
